import { render, staticRenderFns } from "./projectTable.vue?vue&type=template&id=2cd82c80&scoped=true&"
import script from "./projectTable.vue?vue&type=script&lang=js&"
export * from "./projectTable.vue?vue&type=script&lang=js&"
import style0 from "./projectTable.vue?vue&type=style&index=0&id=2cd82c80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd82c80",
  null
  
)

export default component.exports